import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useInTransitJobs } from 'hooks/useInTransitJobs/useInTransitJobs';
import { useTranslation } from 'react-i18next';
import Spinner from 'components/Spinner';
import JourneysList from 'components/JourneysList';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';

const InTransitJobs = ({ className }) => {
  const { inTransitJobs, error, loading } = useInTransitJobs();
  const { t } = useTranslation('Jobs');
  let history = useHistory();

  const handleClick = useCallback(
    id => history.push(`${ROUTES.IN_TRANSIT_DETAIL.DEFAULT}/${id}`),
    [history]
  );

  const renderInTransitJobs = useCallback(() => {
    if (loading) {
      return (
        <div className="in-transit-jobs__loading">
          <Spinner />
        </div>
      );
    }

    if (error) {
      return <div>{t('error')}</div>;
    }

    if (!inTransitJobs || inTransitJobs.length === 0) {
      return (
        <div className="in-transit-jobs__alert">{t('noInTransitJobs')}</div>
      );
    }

    return (
      <JourneysList
        journeys={inTransitJobs}
        parentClass="in-transit-jobs"
        handleClick={handleClick}
      />
    );
  }, [error, loading, inTransitJobs, t, handleClick]);

  return (
    <div className={className}>
      <div className="in-transit-jobs">
        <div className="in-transit-jobs__container">
          {renderInTransitJobs()}
        </div>
      </div>
    </div>
  );
};

InTransitJobs.propTypes = {
  className: PropTypes.string
};

export default InTransitJobs;
